import { ESupportTicketSource } from "../../aiTickets.types";

interface Props {
  source: ESupportTicketSource;
  size?: number;
}

const WhatsAppIcon = ({ size }: { size: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2C6.48 2 2 6.48 2 12c0 1.85.5 3.58 1.37 5.06L2 22l5.07-1.36A9.96 9.96 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2Z"
      fill="#25D366"
    />
    <path
      d="M17.5 14.39c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.93 1.17-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.49-.9-.8-1.5-1.79-1.67-2.09-.18-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.91-2.18-.24-.57-.49-.49-.66-.5h-.56c-.2 0-.5.07-.77.37-.27.3-1.02 1-1.02 2.44 0 1.44 1.05 2.83 1.2 3.03.15.2 2.07 3.16 5.02 4.43.7.3 1.25.48 1.68.62.7.22 1.34.19 1.84.12.56-.08 1.77-.72 2.02-1.41.25-.7.25-1.3.17-1.41-.08-.12-.27-.2-.57-.34Z"
      fill="#fff"
    />
  </svg>
);

const InAppIcon = ({ size }: { size: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M3 11.5C3 6.81 6.81 3 11.5 3C16.19 3 20 6.81 20 11.5C20 16.19 16.19 20 11.5 20C10.25 20 9.06 19.73 7.99 19.24L4.55 20.9C4.21 21.06 3.81 21.02 3.51 20.8C3.2 20.58 3.05 20.2 3.1 19.83L3.59 16.68C3.21 15.69 3 14.63 3 11.5Z"
      fill="#FB3973"
    />
    <circle cx="8" cy="11.5" r="1" fill="#fff" />
    <circle cx="11.5" cy="11.5" r="1" fill="#fff" />
    <circle cx="15" cy="11.5" r="1" fill="#fff" />
  </svg>
);

const ChannelIcon = ({ source, size = 24 }: Props) => {
  if (source === ESupportTicketSource.WhatsApp)
    return <WhatsAppIcon size={size} />;
  return <InAppIcon size={size} />;
};

export default ChannelIcon;
